import { APIModel } from './api-model.model'

export class APIReportCategory extends APIModel {
    categoryId: number;
    categoryName: string;
    categoryEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        categoryId: number;
        categoryName: string;
        categoryEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.categoryId = params.categoryId
        this.categoryName = params.categoryName
        this.categoryEnabled = params.categoryEnabled ? 1 : 0
    }
}
